import { Button } from "@material-ui/core";
import { DataGrid, GridColDef } from "@material-ui/data-grid";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import IssuesService from "../../../services/issues-service/IssuesService";
import { useForm } from "react-hook-form";
import moment from 'moment-timezone';
import CustomNoRowsOverlay from "../../../components/NoRecord";
import SpinnerLoader from "../../../components/spinner-loader/SpinnerLoader.component";
import DOMPurify from 'dompurify';
const CallLog: any = [];

function Issues(props: any) {
  const [showGrid, setShowGrid] = useState(true);
  const [activeSection, setActiveSection] = useState('calls');

  const {
    register: searchCallLog,
    getValues: getValuesSearchCallLog,
    setValue: setValuesSearchCallLog,
  } = useForm({
    defaultValues: {
      status: "Open",
    },
  });

  const { register, handleSubmit, reset, errors, } = useForm();

  const columns: GridColDef[] = [
    { field: "id", hide: true },
    { field: "displayNumber", headerName: "Issue Number", width: 200 },
    {
      field: "fullName", headerName: "User", width: 200,
      renderCell: (params: any) =>
        params.row.isActive ?
          params.row.isDeleted ? "**" + params.row.fullName : params.row.fullName
          : "*" + params.row.fullName
    },
    { field: "description", headerName: "Description", flex: 1 },
    {
      field: "statusDate",
      headerName: "Date",
      width: 200,
      align: "left",
      valueFormatter: (params) =>
        moment(params.row?.statusDate).format("MM/DD/YYYY hh:mm A"),
    },
    { field: "issueStatus", headerName: "Status", width: 120, align: "left" },
    {
      field: "col4",
      headerName: " ",
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <Button
          style={{ background: "#bfa056", color: "#fff" }}
          variant="contained"
          className="MuiButton-textSizeSmall"
          onClick={() =>
            review(callLogs.find((e: any) => e.id == params.row.id))
          }
        >
          {params.row.issueStatus == "Closed" ? "View" : "Review"}
        </Button>
      ),
    },
  ];

  const [callLogs, setCallLogs] = useState(CallLog);
  const [currentCallLogs, setCurrentCallLogs] = useState<any>({});
  const [detail, setDetail] = useState(false);
  const [showMsgDailog, setMsgDialog] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>({});
  const closeDetail = () => setDetail(false);
  const openDetail = () => setDetail(true);

  const review = (callLog: any) => {
    setCurrentCallLogs(callLog);
    openDetail();
  };

  const columns2: GridColDef[] = [
    { field: "id", hide: true },
    { field: "displayNumber", headerName: "Issue Number", width: 200 },
    {
      field: "fullName", headerName: "User", width: 200,
      renderCell: (params: any) =>
        params.row.isActive ?
          params.row.isDeleted ? "**" + params.row.fullName : params.row.fullName
          : "*" + params.row.fullName
    },
    { field: "description", headerName: "Description", flex: 1 },
    {
      field: "statusDate",
      headerName: "Date",
      width: 200,
      align: "left",
      valueFormatter: (params) =>
        moment(params.row?.statusDate).format("MM/DD/YYYY hh:mm A"),
    },
    { field: "issueStatus", headerName: "Status", width: 120, align: "left" },
    {
      field: "col4",
      headerName: " ",
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <Button
          style={{ background: "#bfa056", color: "#fff" }}
          variant="contained"
          className="MuiButton-textSizeSmall"
          onClick={() =>
            review(callLogs.find((e: any) => e.id == params.row.id))
          }
        >
          {params.row.issueStatus == "Closed" ? "View" : "Review"}
        </Button>
      ),
    },
  ];

  const getCallLog = () => {
    if (activeSection.toLocaleLowerCase() == "calls") {
      setShowGrid(false);
      setCallLogs(CallLog);
      IssuesService.getAll(getValuesSearchCallLog("status"))
        .then((res) => {
          setCallLogs(res.data.result);
          setShowGrid(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setShowGrid(false);
      IssuesService.getAllMsg(getValuesSearchCallLog("status"))
        .then((res) => {
          setCallLogs(res.data.result);
          setShowGrid(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getMSGLog = () => {
    setShowGrid(false);
    setCallLogs(CallLog);
    IssuesService.getAllMsg(getValuesSearchCallLog("status"))
      .then((res) => {
        setCallLogs(res.data.result);
        setShowGrid(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const status = getValuesSearchCallLog("status") || "Open";
    setShowGrid(false);

    const fetcher =
      activeSection === "calls"
        ? IssuesService.getAll
        : IssuesService.getAllMsg;

    fetcher(status)
      .then(res => {
        setCallLogs(res.data.result);
      })
      .catch(err => {
        console.error("API Error:", err);
      })
      .finally(() => setShowGrid(true));

  }, [activeSection]);

  const submit = (data: any, issueStatus: any) => {
    var date = moment();
    data.id = currentCallLogs.id;
    data.issueStatus = issueStatus;
    data.issueNumber = currentCallLogs.issueNumber;
    if (
      currentCallLogs.comments != "" &&
      currentCallLogs.comments != null &&
      currentCallLogs.comments != undefined
    ) {
      data.comments =
        currentCallLogs.comments +
        "\n" +
        date.tz('America/New_York').format("MM/DD/YYYY hh:mm A") + ' EST' +
        " - " +
        data.comments;
    } else {
      data.comments =
        date.tz('America/New_York').format("MM/DD/YYYY hh:mm A") + " EST - " + data.comments;
    }

    if (activeSection.toLocaleLowerCase() == "calls") {
      IssuesService.save(data)
        .then((res) => {
          if (res.data.message == "updated") {
            getCallLog();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      IssuesService.updateChatIssue(data)
        .then((res) => {
          if (res.data.message == "updated") {
            getMSGLog();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    closeDetail();
  };

  return (
    <div className="">
      <SpinnerLoader
        isGeneral={true}
        tasksList={[
          'getcalllogissues',
          'getMsgLogIssues',
          'updatecalllogissue',
          'getmessageissues',
        ]}
        inInternal={false}
      />

      <h3 className="mb-3">Issues</h3>
      <form autoComplete="off" className="form-inline" noValidate>
        <div className="form-group mb-2">
          <div className="p-2">
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="All"
                id="all"
                ref={searchCallLog}
                name="status"
                checked={getValuesSearchCallLog("status") === "All"}
                className="custom-control-input"
                onChange={getCallLog}
              />
              <label className="custom-control-label" htmlFor="all">All</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="Open"
                id="open"
                defaultValue={"Open"}
                checked={getValuesSearchCallLog("status") === "Open"}
                ref={searchCallLog}
                name="status"
                className="custom-control-input"
                onChange={getCallLog}
              />
              <label className="custom-control-label" htmlFor="open">Open</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="In Progress"
                id="inprogress"
                ref={searchCallLog}
                name="status"
                checked={getValuesSearchCallLog("status") === "In Progress"}
                className="custom-control-input"
                onChange={getCallLog}
              />
              <label className="custom-control-label" htmlFor="inprogress">In Progress</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="Closed"
                id="closed"
                ref={searchCallLog}
                name="status"
                className="custom-control-input"
                checked={getValuesSearchCallLog("status") === "Closed"}
                onChange={getCallLog}
              />
              <label className="custom-control-label" htmlFor="closed">Closed</label>
            </div>
          </div>
        </div>
      </form>

      <div className="row m-0">
        <div className="col-10 p-0">
          <div style={{ paddingBottom: "40px", width: "120%" }}>
            <div className="tab-wrapper">
              <div className="tab-header">
                <button
                  className={`tab-button ${activeSection === 'calls' ? 'active' : ''}`}
                  onClick={() => setActiveSection('calls')}
                >
                  Calls
                </button>
                <button
                  className={`tab-button ${activeSection === 'messages' ? 'active' : ''}`}
                  onClick={() => setActiveSection('messages')}
                >
                  Messages
                </button>
              </div>
            </div>

            <div className="tab-content">
              {activeSection === 'calls' && (
                <>
                  {showGrid ? (
                    <div className="data-grid">
                      <DataGrid
                        components={{ NoRowsOverlay: CustomNoRowsOverlay }}
                        columns={columns}
                        rows={callLogs}
                        pageSize={10}
                        autoHeight={true}
                        disableColumnMenu={true}
                        disableSelectionOnClick={true}
                      />
                      <div style={{ marginTop: '10px' }}>
                        <p style={{ fontSize: '15px' }}><strong>*</strong> Deactivated User</p>
                        <p style={{ marginTop: '-15px', fontSize: '15px' }}><strong>**</strong> Deleted User</p>
                      </div>
                    </div>
                  ) : ''}
                </>
              )}

              {activeSection === 'messages' && (
                <>
                  {showGrid ? (
                    <div className="data-grid">
                      <DataGrid
                        components={{ NoRowsOverlay: CustomNoRowsOverlay }}
                        rows={callLogs}
                        columns={columns2}
                        pageSize={10}
                        autoHeight={true}
                        disableColumnMenu={true}
                        disableSelectionOnClick={true}
                      />
                      <div style={{ marginTop: '10px' }}>
                        <p style={{ fontSize: '15px' }}><strong>*</strong> Deactivated User</p>
                        <p style={{ marginTop: '-15px', fontSize: '15px' }}><strong>**</strong> Deleted User</p>
                      </div>
                    </div>
                  ) : ''}
                </>
              )}
            </div>
          </div>

          {/* Calls Modal */}
          <Modal centered show={activeSection === 'calls' && detail} onHide={closeDetail} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>Issue</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="col-12 mt-2" autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-2">
                    <label className="lbl">Issue Number</label>
                  </div>
                  <div className="col-3">
                    <p className="">{currentCallLogs.displayNumber}</p>
                  </div>
                  <div className="col-2">
                    <label className="lbl">Name</label>
                  </div>
                  <div className="col-3">
                    <p className="">{currentCallLogs.fullName}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2">
                    <label className="lbl">Description</label>
                  </div>
                  <div className="col-10">
                    <p className="text-wrap">{currentCallLogs.description}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2">
                    <label className="lbl">Date</label>
                  </div>
                  <div className="col-3">

                    <p className="">
                      {moment(currentCallLogs.statusDate).format("MM/DD/YYYY hh:mm A")}
                    </p>

                  </div>
                  <div className="col-2">
                    <label className="lbl">Status</label>
                  </div>
                  <div className="col-3">
                    <p className="">{currentCallLogs.issueStatus}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2">
                    <label className="lbl">Previous Comments</label>
                  </div>
                  <div className="col-10">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(currentCallLogs?.comments ?? '')
                      }}
                    />
                  </div>
                </div>
                {currentCallLogs.issueStatus == "Closed" ? (
                  ""
                ) : (
                  <div className="form-group">
                    <div className="row">
                      <div className="col-2">
                        <label className="lbl">Comments</label>
                        <span className="text-danger"> *</span>
                      </div>
                      <div className="col-10">
                        <textarea
                          name="comments"
                          ref={register({ required: true })}
                          className="form-control"
                          placeholder="comments"
                        />
                        {errors.comments && (
                          <span className="text-danger">Comments are required</span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <br />
                <div className="pull-right p-3">
                  <Button className="mr-2" variant="contained" onClick={closeDetail}>
                    Cancel
                  </Button>
                  {currentCallLogs.issueStatus == "In Progress" ||
                    currentCallLogs.issueStatus == "Closed" ||
                    (currentCallLogs.issueStatus === "Open" &&
                      (currentCallLogs.isActive == false || currentCallLogs.isDeleted == true)) ? (
                    ""
                  ) : (
                    <Button
                      variant="contained"
                      style={{ background: "#bfa056", color: "#fff" }}
                      onClick={handleSubmit((data) => submit(data, "In Progress"))}
                    >
                      In Progress
                    </Button>
                  )}
                  {currentCallLogs.issueStatus == "Closed" ||
                    (currentCallLogs.issueStatus === "Open" &&
                      (currentCallLogs.isActive == false || currentCallLogs.isDeleted == true)) ? (
                    ""
                  ) : (
                    <Button
                      className="ml-2"
                      style={{ background: "#bfa056", color: "#fff" }}
                      variant="contained"
                      onClick={handleSubmit((data) => submit(data, "Closed"))}
                    >
                      Close
                    </Button>
                  )}
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* Messages Modal */}
          {activeSection === 'messages' && (
            <Modal centered show={detail} onHide={closeDetail} size="xl">
              <Modal.Body>
                <form autoComplete="off" noValidate>
                  <div className="modal-header">
                    <div className="modal-title h4">Issue</div>
                  </div>
                  <div className="modal-body-bx request-mod">

                    {/* Left: Message Details */}
                    <div style={{ width: '50%' }}>
                      <h5>Message Details</h5>
                      <div className="row">
                        <div className="row w50">
                          <label className="t-primary">Message From: </label>
                          <p className="ml-1 label-txt font-weight-bold">{currentCallLogs.messageFromFullName}</p>
                        </div>
                        <div className="row w100">
                          <label className="t-primary row">Message To: </label>
                          <p className="ml-4 label-txt font-weight-bold">{currentCallLogs.messageToFullName}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="row w15">
                          <label className="t-primary">Message Type: </label>
                          <p className="ml-4 label-txt font-weight-bold">{currentCallLogs.messageType}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="row w100">
                          <label className="t-primary">Message Date: </label>
                          <p className="ml-4 label-txt font-weight-bold">

                            {moment(currentCallLogs.reportDate).format("MM/DD/YYYY hh:mm A") + " EST"}

                          </p>
                        </div>

                      </div>

                      {/* Original Message — now under Message Type */}
                      <div className="group-field">
                        <label className="m-1 t-primary">Original Message</label>
                        {currentCallLogs?.messageType?.toLowerCase() === "audio" ? (
                          <audio controls style={{ width: "70%", marginLeft: "18px", marginBottom: "15px" }}>
                            <source src={currentCallLogs.sendMessageAudioUrl} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        ) : (
                          <textarea
                            className="form-control form-control-sm"
                            disabled
                            defaultValue={currentCallLogs.sendMessageContent}
                            style={{ width: "70%", marginLeft: "18px", marginBottom: "7px", resize: "none" }}
                          />
                        )}
                      </div>

                      {/* Reply Message — now under Original Message */}
                      <div className="group-field">
                        <label className="m-1 t-primary">Reply Message</label>
                        {currentCallLogs?.audioMessageURL !== "" && currentCallLogs?.audioMessageURL !== null ? (
                          <audio controls style={{ width: "70%", marginLeft: "18px" }}>
                            <source src={currentCallLogs.audioMessageURL} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        ) : (
                          <textarea
                            className="form-control form-control-sm"
                            disabled
                            defaultValue={currentCallLogs.replyMessageContent}
                            style={{ width: "70%", marginLeft: "18px", marginBottom: "7px", resize: "none" }}
                          />
                        )}
                      </div>
                    </div>

                    <div className="vl vl2" style={{ height: '290px', alignSelf: 'flex-start' }}></div>

                    {/* Right: Request Details */}
                    <div style={{ width: '47%' }}>
                      <h5>Request Details</h5>
                      <div className="row">
                        <label className="t-primary">Issue Number: </label>
                        <p className="ml-1 label-txt font-weight-bold">{currentCallLogs.displayNumber}</p>
                      </div>
                      <div className="row">
                        <label className="t-primary">Requested By: </label>
                        <p className="ml-1 label-txt font-weight-bold">{currentCallLogs.fullName}</p>
                      </div>
                      <div className="row">
                        <label className="t-primary">Request Date: </label>
                        <p className="ml-1 label-txt font-weight-bold">
                          {moment(currentCallLogs.reportedDate).format("MM/DD/YYYY hh:mm A")}
                        </p>
                      </div>
                      <div className="row">
                        <label className="t-primary">Request Status: </label>
                        <p className="ml-1 label-txt font-weight-bold">{currentCallLogs.status}</p>
                      </div>
                      <div className="row">
                        <label className="t-primary">Status Date: </label>
                        <p className="ml-1 label-txt font-weight-bold">
                          {moment(currentCallLogs.statusDate).format("MM/DD/YYYY hh:mm A") + ""}
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="description-section" style={{ padding: '10px 16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <label className="t-primary font-weight-bold" style={{ width: '180px', minWidth: '180px' }}>Description</label>
                      <p className="label-txt" style={{ margin: 0 }}>{currentCallLogs.description}</p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <label className="t-primary font-weight-bold" style={{ width: '180px', minWidth: '180px' }}>Previous Comments</label>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(currentCallLogs?.comments ?? '')
                        }}
                      />
                    </div>
                    {currentCallLogs.issueStatus == "Closed" ? (
                      ""
                    ) : (
                      <div className="form-group">
                        <div className="row">
                          <div className="col-2">
                            <label className="lbl">Comments</label>
                            <span className="text-danger"> *</span>
                          </div>
                          <div className="col-10">
                            <textarea
                              name="comments"
                              ref={register({ required: true })}
                              className="form-control"
                              placeholder="comments"
                            />
                            {errors.comments && (
                              <span className="text-danger">Comments are required</span>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <hr />

                  <div className="pull-right p-3">
                    <Button className="mr-2" variant="contained" onClick={closeDetail}>
                      Cancel
                    </Button>
                    {currentCallLogs.issueStatus == "In Progress" ||
                      currentCallLogs.issueStatus == "Closed" ||
                      (currentCallLogs.issueStatus === "Open" &&
                        (currentCallLogs.isActive == false || currentCallLogs.isDeleted == true)) ? (
                      ""
                    ) : (
                      <Button
                        variant="contained"
                        style={{ background: "#bfa056", color: "#fff" }}
                        onClick={handleSubmit((data) => submit(data, "In Progress"))}
                      >
                        In Progress
                      </Button>
                    )}
                    {currentCallLogs.issueStatus == "Closed" ||
                      (currentCallLogs.issueStatus === "Open" &&
                        (currentCallLogs.isActive == false || currentCallLogs.isDeleted == true)) ? (
                      ""
                    ) : (
                      <Button
                        className="ml-2"
                        style={{ background: "#bfa056", color: "#fff" }}
                        variant="contained"
                        onClick={handleSubmit((data) => submit(data, "Closed"))}
                      >
                        Close
                      </Button>
                    )}
                  </div>
                </form>
              </Modal.Body>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
}

export default Issues;